import styled from "styled-components";
import { Avatar } from '@mui/material';

const SideBar1 = styled.div`
    background: ${props => props.theme.colors.silverGrayThree};
    transition: width 0.3s ease, transform 0.3s ease;
    width: ${props => {
        if (props.$isCollapsedForDocument) return '10%';
        return props.isExpanded ? (props.isMobile ? '100%' : '388px') : '72px';
    }};
    min-width: ${props => props.$isCollapsedForDocument ? '60px' : '72px'};
    max-width: ${props => props.$isCollapsedForDocument ? '80px' : (props.isExpanded ? '388px' : '72px')};
    overflow: hidden;
    padding: ${props => props.$isCollapsedForDocument ? '8px' : '16px'};
    display: flex;
    flex-direction: column;
    gap: 16px;
    height: calc(100vh - 1.75rem);
	  max-height: calc(100vh - 1.75rem);

    & div > div > div {
        font-size: 0.875rem;
    }
	
    & div > div > img {
        cursor: pointer;
    }
	
    border-top-right-radius: 16px;
`;

const CollapseContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: ${props => props.isExpanded ? 'flex-start' : 'center'};
    align-items: center;
    cursor: pointer;
	gap: 16px;
`;

const ListOfAgentContainer = styled.div`
	display:flex;
    justify-content: flex-start;
	width: 100%;
	flex-grow: 0;
    max-height: calc(50% - 40px);
	
	.agent-title{
		font-size: 14px;
		font-weight: bold;
	}
`;

const AgentListContainer = styled.div`
    height: auto;
	overflow-y: auto;
	scrollbar-width: thin;
	scroll-margin-left: 8px;
	scrollbar-color: ${props => props.theme.colors.thumbGray} ${props => props.theme.colors.highClearGray};
	width: 100%;
`;

const AgentListCard = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: space-between;
    align-content: stretch;
    align-items: center;
    width: 100%;
    min-height: 67px;
    gap: 24px;
    cursor: pointer;
	padding: 8px 16px;
	background: ${props => props.isSelected ?  props.theme.colors.titanWhite : 'transparent'};
	font-weight: ${props => props.isSelected ?  'bold' : 'normal'};
	
	border-radius: ${props => props.isSelected ? '8px' : '0px'};
	
	& div:nth-child(2){
		gap: 0;
	}
`;

const AgentAvatar = styled.div`
    order: 0;
    flex: 0 1 auto;
    align-self: auto;
    display: flex;
	max-width: 40px;
	max-height: 40px;
`;

const AgentData = styled.div`
    order: 0;
    flex: 1 1 auto;
    align-self: auto;
    display: flex;
    flex-direction: column;
    gap:8px;
`;

const AgentFavorites = styled.div`
    order: 0;
    flex: 1 1 auto;
    align-self: auto;
    display:flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 14px;
`;

const AgentName = styled.p`
    margin: 0;
    overflow: hidden;
    white-space: nowrap; 
    text-overflow: ellipsis;
    width: 170px;  /*Temporary to 170px while favorites is ready otherwise the value is 100px*/
	font-size: 0.875rem;

    @media (max-width: 768px) {
        width: 140px;
        font-size: 0.8125rem;
    }
`;

const AgentWelcome = styled.p`
    margin: 0;
    font-weight: normal;
    font-size: 14px;
    color: ${props => props.theme.colors.grayX11};
`;

const AgentDateTime = styled.p`
    margin: 0;
    font-weight: normal;
    font-size: 10px;
    color: ${props => props.theme.colors.grayX11};
`;

const InputWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-end;
    border-radius: 8px;
    border: 1px solid ${(props) => props.theme.colors.clearGray};
    background: ${(props) => props.theme.colors.white};
    height: 40px;
    padding-right: 5px;
	width: 100%;

    @media (max-width: 768px) {
        height: 28px;
    }
`;

const InputField = styled.input`
    width: 100%;
	height: auto;
    max-height: 20px;
    border: none;
    outline: none;
    padding: 0 10px;
    background: ${(props) => props.theme.colors.white};
    ${(props) => props.theme.fonts.variant.regular()};

    ::placeholder {
        color: ${(props) => props.theme.colors.clearGray};
    }

    @media (max-width: 768px) {
        font-size: 0.8125rem;
    }
`;

const SearchIcon = styled.div`
    display: block;
    margin: auto;
    
	
	& > div {
        height: 40px;
	}
`;

const Sidebar1Header = styled.div `
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	align-content: flex-start;
	gap:15px;
	max-height: 40px;
	width: 100%;

    @media (max-width: 768px) {
        max-height: 30px;
    }
`;

const AgentWrapper = styled.div`
	display: flex;
	flex-direction: column;
	flex-grow: 1;
    height: calc(100% - 45px);
    overflow: hidden;
	gap:16px;
	
	& > div:nth-child(1) > div:nth-child(2){
		display:flex;
		width: 100%;
	}
`;

const AgentListMainWrapper = styled.div`
	display: flex;
	flex-direction: column;
`;

const AgentListCollapsedHeader = styled.div`
	display:flex;
	justify-content: space-between;
`
const SliceButton = styled.button`
    display: none;
    position: fixed;
    top: 60px;
    left: 10px;
    z-index: 1001;
    background: ${props => props.theme.colors.silverGrayThree};
    border: none;
    border-radius: 50%;
    width: 40px;
    height: 40px;
    cursor: pointer;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);

    @media (max-width: 1024px) {
        display: contents;
        align-items: center;
        justify-content: center;
    }
`;

const IconContainer = styled.div`
    width: 40px;
    height: 40px;
    border-radius: 8px;
    border: 1px solid ${(props) => props.theme.colors.clearGray};
    padding: 8px;
    gap: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
`;

const CollapseIconWrapper = styled.div`
    display: flex;
    justify-content: flex-end;
    margin-bottom: 0px;
	order:1;
`;

const ExpandIconWrapper = styled.div`
    display: flex;
    justify-content: center;
    width: 100%;
    margin-bottom: 8px;
`;

const ExploreAgentsContainer = styled.div`
    height: 40px;
    padding: 12px 16px;
    display: flex;
    align-items: center;
    font-weight: bold;
	font-size: 14px;
	flex-direction: row;
	justify-content: space-between;
	cursor: pointer;
	
	&:hover {
		background-color: ${props => props.theme.colors.white};
		border-radius: 8px;
		.arrow-icon {
			opacity: 1;
		}
	}
	.arrow-icon {
		opacity: 0;
		transition: opacity 0.2s ease;
	}
`;

const HistoryContainer = styled.div`
	width: 100%;
	display: flex;
	flex-direction: column;
	flex-grow: 0;
    flex-shrink: 0;
    height: calc(50% - 40px);
    max-height: 50%;
	overflow: hidden;
`;

const StyledAvatar = styled(Avatar)`
	opacity: ${(props) => props.isLoading ? 0 : 1}
	transition: opacity 0.3s ease-in-out
`;

export {
	SideBar1,
	CollapseContainer,
	ListOfAgentContainer,
	AgentListContainer,
	AgentName,
	AgentWelcome,
	AgentListCard,
	AgentAvatar,
	AgentData,
	AgentFavorites,
	AgentDateTime,
	InputWrapper,
	InputField,
	SearchIcon,
	Sidebar1Header,
	AgentWrapper,
	AgentListMainWrapper,
	AgentListCollapsedHeader,
    SliceButton,
    IconContainer,
    CollapseIconWrapper,
    ExpandIconWrapper,
	ExploreAgentsContainer,
	HistoryContainer,
	StyledAvatar,
}